export const ACTIONS = [
  { key: "doc:add", label: "Add" },
  { key: "doc:view", label: "View" },
  { key: "doc:update", label: "Update" },
  { key: "doc:delete", label: "Delete" },
  { key: "doc:share", label: "Share" },
  { key: "meta:view", label: "View meta" },
  { key: "meta:edit", label: "Edit meta" },
];

export const PRESETS = [
  { value: "custom", label: "Custom" },
  { value: "none", label: "None" },
  { value: "read", label: "Read" },
  { value: "write", label: "Write" },
  { value: "admin", label: "Admin" },
];

export const presetToActions = (preset) => {
  switch (preset) {
    case "read":
      return ["doc:view", "meta:view"];
    case "write":
      return ["doc:view", "doc:add", "doc:update", "meta:view", "meta:edit", "doc:share"];
    case "admin":
      return ["doc:add", "doc:view", "doc:update", "doc:delete", "doc:share", "meta:view", "meta:edit"];
    case "none":
    default:
      return [];
  }
};